import React, { ReactElement } from 'react'
import { TableProps } from 'antd'

import { useMatchBreakpoints } from '../../../packages/uikit/src/hooks'
import DesktopTable, { CustomTableProps } from './TableDesktop'
import TableMobile, { TableMobileProps, TableMobileColumnType } from './TableMobile'

export type { TableMobileProps as CustomTableProps, TableMobileColumnType as CustomTableColumnType }

const Table: <T extends object = any>(props: CustomTableProps<T>, context?: any) => ReactElement<any, any> | null = ({
  isMobileView = true,
  ...props
}) => {
  const { isMobile } = useMatchBreakpoints()

  if (isMobile && isMobileView) {
    return <TableMobile {...props} />
  }

  return <DesktopTable {...props} />
}

export default Table
